import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { setPageNameHeader } from "src/redux/actions/header";

import OperationalAwareness from "../OperationalAwareness";

export default function WorkOrderOverview() {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setPageNameHeader("Operational Awareness"));
    return () => {
      dispatch(setPageNameHeader(""));
    };
  }, []);

  return (
    <>
      <OperationalAwareness />
    </>
  );
}
